module.exports = __webpack_public_path__ + "static/media/13.f0d0ccb9.JPEG";